module.exports = __webpack_public_path__ + "static/sf_15.bb76b37e.png";